import { Skeleton, Box, type SkeletonProps } from '@mui/material';

import styles from './styles';

function PropertyCardSkeleton() {
  const props: SkeletonProps = {
    animation: 'wave',
    variant: 'text'
  };

  return (
    <div>
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={styles.skeletonImage}
      />
      <Skeleton {...props} sx={styles.skeletonTitle} />
      <Box sx={styles.skeletonIcons}>
        <Skeleton {...props} />
        <Skeleton {...props} />
        <Skeleton {...props} />
      </Box>
      <Skeleton sx={styles.skeletonPrice} {...props} />
      <Skeleton sx={styles.skeletonCalcLink} {...props} />
    </div>
  );
}

export { PropertyCardSkeleton };
